module.exports = __webpack_public_path__ + "static/android-chrome-192x192-926be4445430497baee156d9026ede4b.png";